import { cn } from "@/lib/utils";
import { CLASS_BY_TOKEN } from "@/lib/classes";
import type { ClassToken } from "@/lib/types";

interface Props {
  classToken: ClassToken;
  size?: number;
  className?: string;
}

/**
 * WoW class icon. Uniform neutral framing — class color is already
 * conveyed by the label color, doubling up here made transparent-edge
 * icons (DK, Druid, Monk) look louder than opaque-edge ones.
 */
export function ClassIcon({ classToken, size = 32, className }: Props) {
  const cls = CLASS_BY_TOKEN[classToken];
  const url = `/icons/${cls.iconName.toLowerCase()}.png`;
  return (
    <span
      className={cn(
        "inline-block shrink-0 overflow-hidden rounded-xs",
        "bg-surface-2",
        className,
      )}
      style={{ width: size, height: size }}
      aria-label={cls.name}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={url}
        alt={cls.name}
        width={size}
        height={size}
        className="block h-full w-full"
        loading="lazy"
      />
    </span>
  );
}
